import {CatalogPage} from '../../shared/catalog/CatalogPage';
import {registerComponent} from '../../shared/react/registrar';

registerComponent(CatalogPage, `CatalogPage`);
